(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlideshow(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slideshow__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-slideshow__dot'));
      var prevBtn = root.querySelector('[data-slide-prev]');
      var nextBtn = root.querySelector('[data-slide-next]');
      var current = 0;
      var timer = null;
      var autoplay = root.dataset.autoplay === 'true';
      var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
      var pauseOnHover = root.dataset.pauseHover === 'true';

      if (slides.length < 2) return;

      function goTo(index) {
        var next = (index + slides.length) % slides.length;
        slides[current].classList.remove('is-active');
        slides[current].classList.remove('is-prev');
        slides[current].setAttribute('aria-hidden', 'true');
        if (next < current) {
          slides[current].classList.add('is-prev');
        }
        slides[next].classList.add('is-active');
        slides[next].setAttribute('aria-hidden', 'false');
        if (dots[current]) {
          dots[current].classList.remove('is-active');
          dots[current].setAttribute('aria-selected', 'false');
        }
        if (dots[next]) {
          dots[next].classList.add('is-active');
          dots[next].setAttribute('aria-selected', 'true');
        }
        current = next;
      }

      function nextSlide() {
        goTo(current + 1);
      }

      function prevSlide() {
        goTo(current - 1);
      }

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        timer = setInterval(nextSlide, speed);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          nextSlide();
          startAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prevSlide();
          startAutoplay();
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          startAutoplay();
        });
      });

      if (pauseOnHover) {
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
      }

      startAutoplay();
    }

    function initAll() {
      document.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-hero-slideshow]');
      if (root) {
        root.dataset.initialized = 'false';
        initHeroSlideshow(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
